import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { MEASURES_NEEDED } from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';

const MAX_CHARACTERS = 500;

const fieldId = MEASURES_NEEDED;

const initialValues = '';

const vFParams = {
  fieldTitle: 'What measures need to be put in place to ensure this root cause is corrected and the change is implemented successfully next time? (optional)',
  placeholder: 'Enter text',
  characterLimit: MAX_CHARACTERS,
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_TEXTAREA);
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);
  // Dynamically reduces charaters limit by 6 char for '<' special character.
  const specialCharCount = (values[fieldId] !== null) ? (values[fieldId].match(/</g) || '').length : 0;
  vFParams.characterLimit = 500;
  if (specialCharCount > 0) {
    vFParams.characterLimit -= (specialCharCount * 6);
  }
  // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);
  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && optional) ? '' : null);
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  // errors[INLINE_ERRORS].push((noValue && !optional) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);
  // errors[SILENT_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);
  // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const measuresNeeded = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_TEXTAREA,
};

export { measuresNeeded };
